import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import HomePage from './pages/HomePage';
import DocumentiPage from './pages/DocumentiPage';
import LettereIntentoPage from './pages/LettereIntentoPage';
import LogsPage from './pages/LogsPage';
import OreConfermatePage from './pages/OreConfermatePage';
import LoginPage from './pages/LoginPage';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Route pubblica per il login */}
          <Route path="/login" element={<LoginPage />} />

          {/* Route protette */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/documenti" element={<DocumentiPage />} />
                    <Route path="/lettere-intento" element={<LettereIntentoPage />} />
                    <Route path="/ore-confermate" element={<OreConfermatePage />} />
                    <Route path="/logs" element={<LogsPage />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
